/**
 * The languages of the cards for guests besides German (not the language of an app's screens), as
 * SpeiseKarte offers them since 01.11.2026 (S36 there): codes of ISO 639-1, in a fixed order.
 * Portuguese is European, as on EUR-Lex. Turkish since 03.11.2026 (SpeiseKarte S36). Which of them a business can switch on stays with the app.
 */
export const LANGS = ["en", "es", "fr", "it", "nl", "pt", "tr"] as const;
export type Lang = (typeof LANGS)[number];

/** The German names, for the screens of the apps: "Englisch". */
export const LANG_LABELS: Record<Lang, string> = { en: "Englisch", es: "Spanisch", fr: "Französisch", it: "Italienisch", nl: "Niederländisch", pt: "Portugiesisch", tr: "Türkisch" };
/** The language's own name, for the switch on the net: "Español". */
export const LANG_NATIVE: Record<Lang, string> = { en: "English", es: "Español", fr: "Français", it: "Italiano", nl: "Nederlands", pt: "Português", tr: "Türkçe" };
/** The short form, for the switch on the net: "DE · EN". */
export const LANG_SHORT: Record<Lang | "de", string> = { de: "DE", en: "EN", es: "ES", fr: "FR", it: "IT", nl: "NL", pt: "PT", tr: "TR" };

export const isLang = (x: unknown): x is Lang => typeof x === "string" && (LANGS as readonly string[]).includes(x);
